<template>
<div class="container">
    <PauseModal v-if="modal_pause" @restart="
            modal_pause = !modal_pause;
            reset=true;
            play=true;
            playMusic = !playMusic;
        " @closeModal="
            modal_pause = !modal_pause;
            reset=false;
            finish_play();
        " @resume="
            modal_pause = !modal_pause;
            reset=false;
            play=true;
            playMusic = !playMusic;
        " />
    <Congratulations v-if="congrats_modal" @restart="congrats_modal = !congrats_modal" @backToMenu="$emit('backToMenu');" @saveGame="$emit('onSavingGame', displayPhrases); congrats_modal = !congrats_modal;"/>

    <div id="rhythm-container" class="container-2">
        <div class="score-container-rhythm">
            <PhraseDisplay v-if="displayPhrases" :disabled="play" :color="colors['1']" :phrase="displayPhrases['original_beats']" :phraseNumber="1" :levels="displayPhrases['curve']" :alternatives="phrases.alternatives" :choices="displayPhrases['choices']['1']" @altered_option="changeOption" :instrument="displayPhrases.instruments['1']" @change_instrument="changeInstrument" @on_mute="onMute" />
            <PhraseDisplay v-if="displayPhrases" :disabled="play" :color="colors['2']" :phrase="displayPhrases['original_beats']" :phraseNumber="2" :levels="displayPhrases['curve']" :alternatives="phrases.alternatives" :choices="displayPhrases['choices']['2']" @altered_option="changeOption" :instrument="displayPhrases.instruments['2']" @change_instrument="changeInstrument" @on_mute="onMute" />
            <PhraseDisplay v-if="displayPhrases" :disabled="play" :color="colors['3']" :phrase="displayPhrases['original_beats']" :phraseNumber="3" :levels="displayPhrases['curve']" :alternatives="phrases.alternatives" :choices="displayPhrases['choices']['3']" @altered_option="changeOption" :instrument="displayPhrases.instruments['3']" @change_instrument="changeInstrument" @on_mute="onMute" />
        </div>
        <div id="score-container-rhythm-canvas" class="score-container-rhythm-canvas">
            <canvas :id="'canvas-score'" class="canvas"></canvas>
        </div>
        <div id="rhythm-playing-bar" class="playing-line" :class="{'active': active}"></div>
    </div>
    <MidiPlayer :midi="midi" :playMidi="playMusic" :velocity="velocity" @finishedPlaying="finish_play" :reset="reset" @currentPosition="viewPosition"></MidiPlayer>

    <div>
        <div class="complete-melody tamanhoicon" @click="finish">
            <img :src="require('@/assets/buttons/newbuttons/rhythm/submit.svg')" />
        </div>
        <div id="menuritmo_play" class="tamanhoicon play-all">
            <img @click="play_pause" :src="require('@/assets/buttons/newbuttons/rhythm/pause.svg')" v-if="play" />
            <img @click="play_pause" :src="require('@/assets/buttons/newbuttons/rhythm/play.svg')" v-else />
        </div>
 <div>
            <img id="speedbarcaracol" :src="require('@/assets/buttons/newbuttons/speedbar/caracoldanca.svg')" />
              <img id="speedbarcoelho" :src="require('@/assets/buttons/newbuttons/speedbar/coelhodanca.svg')" />
</div>
        <div id="speedbar_play" class="tamanhoicon speed-bar">

            <input type="range" min="0.25" max="2.0" step="0.25" list="tickmarks" v-model="velocity" class="slider" id="Speed-Range-Rhythm">
            <datalist id="tickmarks">
                <option value="0.25"></option>
                <option value="0.5" label="0.5"></option>
                <option value="0.75"></option>
                <option value="1.0" label="1"></option>
                <option value="1.25"></option>
                <option value="1.5" label="1.5"></option>
                <option value="1.75"></option>
                <option value="2.0" label="2"></option>
            </datalist>
        </div>
        <div class="instrument-mute-all" :class="[muted ? 'muted' : '']" id="Mute-Original" @click="muted = !muted">
              <img :src="require('@/assets/buttons/newbuttons/mute/muterhythm.svg')" v-if="muted==true" >
            <img :src="require('@/assets/buttons/newbuttons/mute/unmuterhythm.svg')" v-else>
        </div>

        <div @click="back_phrase('slow')" id="back" class="tamanhoicon" :disabled="back_arrow_disabled">
            <img :src="require('@/assets/buttons/newbuttons/rhythm/seta_esq.svg')" />
        </div>
        <div @click="next_phrase('slow')" id="forward" class="tamanhoicon" :disabled="next_arrow_disabled">
            <img :src="require('@/assets/buttons/newbuttons/rhythm/seta_drt.svg')" />
        </div>
    </div>
</div>
</template>

<script>
import MidiPlayer from "../General/MidiPlayer.vue";
import PhraseDisplay from "@/components/RhythmGame/PhraseDisplay.vue";
import PauseModal from "@/components/RhythmGame/PauseModal.vue";
import Congratulations from "@/components/RhythmGame/Congratulations.vue";

export default {
    name: "Score",
    emits: ['backToMenu', 'restart'],
    components: {
        MidiPlayer,
        PhraseDisplay,
        PauseModal,
        Congratulations,

    },
    created() {
        window.addEventListener("resize", this.resize);
    },
    mounted() {
        this.resize();
    },
    data() {
        return {
            play: false,
            playMusic: false,
            midi: "",
            reset: false,
            active: false,

            colors: {
                '1': '#FFFFFF',
                '2': '#FFFFFF',
                '3': '#FFFFFF'
            },
            displayPhrases: {
                'choices': {
                    '1': [],
                    '2': [],
                    '3': []
                },
                'instruments': {
                    '1': 'Woodblock',
                    '2': 'Triangle',
                    '3': 'Clap',
                },
                'muted': {
                    '1': false,
                    '2': false,
                    '3': false
                }
            },
            currentPhrase: 1,
            currentScroll: 0,
            muted: false,
            velocity: 1.0,

            next_arrow_disabled: false,
            back_arrow_disabled: true,

            modal_pause: false,
            congrats_modal: false,
            alert_modal: false,
        };
    },
    props: {
        phrases: Object,
    },
    methods: {
        finish() {
            this.congrats_modal = true;
            this.play = false;
            this.playMusic = false;
        },
        resize() {
            this.calculateCurves();
            this.drawPhrase();
        },
        changeOption(phr_options) {
            this.displayPhrases['choices'][phr_options[0]][phr_options[1]] = phr_options[2];
        },
        changeInstrument(phrase_line) {
            let poss_instruments = Object.keys(this.$data.instruments.percussion);
            let ind = poss_instruments.indexOf(this.displayPhrases['instruments'][phrase_line]);
            if (ind == poss_instruments.length - 1) {
                ind = -1;
            }

            let next_instrument = poss_instruments[ind + 1];
            this.displayPhrases['instruments'][phrase_line] = next_instrument;
        },
        onMute(phr_options) {
            this.displayPhrases['muted'][phr_options[0]] = phr_options[1];
        },
        calculateCurves() {
            let beats = Object.values(this.phrases.original);
            let curve = beats.map((e) => {
                if (e['notes'][0][3] != 0) return e['notes'][0][3];
                let poss = e['notes'].map((e1) => {
                    return e1[3]
                });
                let non_zero = poss.find((value) => value !== 0);
                if (non_zero !== undefined) return non_zero;
                return 2;
            });
            this.displayPhrases['coord'] = this.calculateCurveFromPoints(curve, 0, null);
            this.displayPhrases['original_beats'] = beats;
            this.displayPhrases['curve'] = curve;
            this.displayPhrases['choices'] = {
                '1': this.phrases.proposals['alt_0'].map((e) => {
                    return e.split(' ');
                }),
                '2': this.phrases.proposals['alt_1'].map((e) => {
                    return e.split(' ');
                }),
                '3': this.phrases.proposals['alt_2'].map((e) => {
                    return e.split(' ');
                }),
            };

            console.log(this.phrases.proposals['alt_0']);
        },
        calculateCurveFromPoints(points, phraseNumber, last_phrase) {
            let width = window.innerWidth * ((points.length + 1) / 5.0);
            let height = window.innerHeight;

            let div_w = width / (points.length + 1);
            let div_h = height / 8;

            let line_3 = [];

            if (phraseNumber == 0) {
                line_3.push({
                    x: 0,
                    y: height / 2.0,
                });
            } else {
                let last_line_3 = last_phrase["coord"]["line_3"];
                line_3.push({
                    x: 0,
                    y: last_line_3[last_line_3.length - 1].y,
                });
            }

            let last_x = 0;
            for (let j = 0; j < points.length; j++) {
                last_x += div_w;

                let num = points[j];
                let y = num * div_h;
                if (num == 1) {
                    y -= div_h / 6.0;
                }
                if (num == 3) {
                    y += div_h / 6.0;
                }

                line_3.push({
                    x: last_x,
                    y: y,
                });
            }

            line_3.push({
                x: last_x + div_w,
                y: height / 2.0,
            });

            // Ajusts curve
            let maxArray = Math.max.apply(null, line_3.map(function (el) {
                return el.y + 2.5 * div_h
            }));
            let minArray = Math.min.apply(null, line_3.map(function (el) {
                return el.y - 0.5 * div_h
            }));
            if (maxArray > window.innerHeight) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y - (window.innerHeight - maxArray) - 5
                    }
                });
            } else if (minArray < window.innerHeight / 9.0) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + (window.innerHeight / 9.0)
                    }
                });
            }

            return {
                line_1: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y - 0.5 * div_h,
                    };
                }),
                line_2: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + div_h,
                    };
                }),
                line_3: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + 2.5 * div_h,
                    };
                }),
            };

        },
        drawPhrase() {

            let canvas = document.getElementById("canvas-score");
            let cv_rect = canvas.getBoundingClientRect();

            let ctx = canvas.getContext("2d");
            let coordinates = this.displayPhrases['coord'];

            cv_rect.width = coordinates['line_1'][coordinates['line_1'].length - 1].x;
            ctx.canvas.width = coordinates['line_1'][coordinates['line_1'].length - 1].x;
            canvas.width = coordinates['line_1'][coordinates['line_1'].length - 1].x;
            canvas.height = cv_rect.height;

            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            for (let line in coordinates) {
                this.draw_curve_aux(ctx, coordinates[line], 0.9, this.colors[line.charAt(line.length - 1)], 3);
            }
            setTimeout(() => {
                this.adjust_positions(1, 'line_1');
                this.adjust_positions(2, 'line_2');
                this.adjust_positions(3, 'line_3');
            }, 0.05);
        },
        adjust_positions(i, line) {
            let coordinates = this.displayPhrases["coord"][line];
            let coord = coordinates.slice(1, coordinates.length - 1);
            //let bmw = (coord[coord.length - 1].x - coord[0].x) / (coord.length);

            // Instrument
            let inst_id = "Instrument-" + i.toString();
            let div = document.getElementById(inst_id);

            if (div != null) {
                div.style.position = "absolute";
                div.style.left = coordinates[0].x + 'px';
                div.style.top = coordinates[0].y - 1.2 * div.clientHeight + 'px';
            }

            // Beats
            for (let j = 0; j < coord.length; j++) {

                let cd = coord[j];

                let id = "Beat-" + i + '-' + j.toString();
                let div = document.getElementById(id);

                if (div != null) {
                    /*div.style.width = bmw + 'px';*/

                    div.style.position = "absolute";
                    div.style.left = cd.x - (div.clientWidth / 4.0) + 'px';
                    div.style.top = cd.y - (div.clientHeight / 2.0) + 'px';
                }
            }
        },
        play_pause() {
            if (this.play) {
                this.popup_pausa();
            } else {
                this.play_music();
            }
        },
        popup_pausa() {
            this.modal_pause = !this.modal_pause;
            this.play = false;
            this.playMusic = !this.playMusic;
        },
        finish_play() {
            this.play = false;
            let container = document.getElementById("rhythm-container");
            container.scrollTo(0, 0);
            this.active = false;
        },
        viewPosition(pos) {

            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("rhythm-container");
            let temp_scroll = 0;

            if (pos !== 'Not Playing') {
                this.active = true;

                let div = document.getElementById('rhythm-playing-bar');
                let canvas_width = canvas.width;
                let first_coord = this.displayPhrases["coord"]['line_1'][1];

                if (div != null) {

                    let posX = pos * canvas_width + first_coord.x - 10;
                    div.style.position = "absolute";
                    div.style.left = posX + 'px';

                    let max_scroll = Math.ceil(canvas_width / window.innerWidth);

                    for (let sX = 0; sX < max_scroll; sX++) {
                        if (posX > sX * window.innerWidth && posX < (sX + 1) * window.innerWidth) {
                            temp_scroll = sX * window.innerWidth;
                            break;
                        }
                    }
                }

            } else {
                this.active = false;
                temp_scroll = 0;
            }

            if (this.currentScroll !== temp_scroll) {
                container.scrollTo(temp_scroll, 0);
                this.currentScroll = temp_scroll;
            }
        },
        back_phrase(mode = 'slow') {
            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("rhythm-container");

            if (mode === 'fast') {
                let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                let num_phrases = Math.ceil(canvas.width / width);
                for (let i = 0; i < num_phrases; i++) {
                    if ((container.scrollLeft >= i * width && i > 0) && container.scrollLeft <= (i + 1) * width) {
                        container.scrollTo((i - 1) * width, 0);
                        break;
                    }
                }
            } else {
                if (container.scrollLeft > 0) {
                    container.scrollTo(container.scrollLeft - canvas.width / 10.0, 0);
                }
            }
            this.enable_buttons(container, canvas);
        },
        next_phrase(mode = 'slow') {
            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("rhythm-container");

            if (mode === 'fast') {
                let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                let num_phrases = Math.ceil(canvas.width / width);
                for (let i = 0; i < num_phrases; i++) {
                    if (container.scrollLeft >= i * width && container.scrollLeft < (i + 1) * width) {
                        container.scrollTo((i + 1) * width, 0);
                        break;
                    }
                }

            } else {
                if (container.scrollLeft < canvas.width - window.innerWidth) {
                    container.scrollTo(container.scrollLeft + canvas.width / 10.0, 0);
                }
            }
            this.enable_buttons(container, canvas);
        },
        enable_buttons(container, canvas) {
            if (container.scrollLeft > 0) {
                this.back_arrow_disabled = false;
            } else {
                this.back_arrow_disabled = true;
            }
            if (container.scrollLeft >= canvas.width - window.innerWidth) {
                this.next_arrow_disabled = true;
            } else {
                this.next_arrow_disabled = false;
            }
        },
        play_music() {

            let phrase = this.phrases['original'];
            let notes = [];
            for (let b in Object.keys(phrase)) {
                let beat = Object.keys(phrase)[b];
                for (let note in phrase[beat]['notes']) {
                    let dur = phrase[beat]['notes'][note][2];
                    if (dur == 1) {
                        dur = this.phrases_g[this.current_phrase]["whole_duration"];
                    }
                    notes.push([phrase[beat]['notes'][note][1], dur]);
                }
            }

            this.midi = {
                'tracks': {
                    '0': {
                        'instrument': this.$data.instruments.harmonic.Piano,
                        'is_percussion': false,
                        'notes': notes,
                        'is_muted': this.muted,
                        'loudness': 1.0
                    },
                    '1': {},
                    '2': {},
                    '3': {}
                },
                'whole_duration': this.phrases['whole_duration'],
                'n_beats': Object.keys(this.phrases['original']),
            };
            for (let i in this.displayPhrases['choices']) {

                let note_i = 'C4';
                if (i == '1') {
                    note_i = 'G5';
                }
                if (i == '3') {
                    note_i = 'E3';
                }

                let instrument = this.$data.instruments.percussion[this.displayPhrases['instruments'][i]];
                this.midi.tracks[i]['instrument'] = instrument.name;
                this.midi.tracks[i]['is_percussion'] = true;
                note_i = instrument.note;
                this.midi.tracks[i]['loudness'] = instrument.velocity;

                this.midi.tracks[i]['notes'] = [];
                this.midi.tracks[i]['is_muted'] = this.displayPhrases['muted'][i];

                for (let el in this.displayPhrases['choices'][i]) {
                    let r_el = this.displayPhrases['choices'][i][el];
                    if (r_el === '') {
                        this.midi.tracks[i]['notes'].push(['R', this.phrases['whole_duration']]);
                    } else {
                        for (let el1 in r_el) {
                            let dur = 0;
                            switch (r_el[el1].split(".")[0]) {
                                case '4':
                                    dur = this.phrases['whole_duration'] * 4;
                                    break;
                                case '5':
                                    dur = this.phrases['whole_duration'] * 2;
                                    break;
                                case '7':
                                    dur = this.phrases['whole_duration'] * 0.5;
                                    break;
                                case '8':
                                    dur = this.phrases['whole_duration'] * 0.25;
                                    break;
                                case '9':
                                    dur = this.phrases['whole_duration'] * 0.125;
                                    break;
                                default:
                                    dur = this.phrases['whole_duration'];
                                    break;
                            }

                            let dots = r_el[el1].split(".").length - 1;
                            if (dots == 1) {
                                dur += 0.5 * dur;
                            } else if (dots == 2) {
                                dur += 0.75 * dur;
                            }

                            this.midi.tracks[i]['notes'].push([note_i, dur]);
                        }
                    }
                }
            }

            let container = document.getElementById("rhythm-container");
            this.currentScroll = container.scrollLeft;

            this.play = true;
            this.playMusic = !this.playMusic;

        }
    }
};
</script>

<style>
#menuritmo_play {
    position: absolute;
    display: flex;
    bottom: 7%;
    justify-content: center;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));

}

#tickmarks{

width: 2rem;
height: 2rem;
color: red;
}

.container {
    width: 100%;
    height: 100%;
}

.container-2 {
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    overflow-x: scroll;
    overflow-y: hidden;
}

.complete {
    position: absolute;
    right: 1rem;
    bottom: 1rem;
}

.edit {
    position: absolute;
    left: 5rem;
    top: 1rem;
}

.play {
    position: absolute;
    right: 5rem;
    top: 1rem;
}

.playsong {

    position: absolute;
    right: 1rem;
    top: 1rem;
}

.score-container-rhythm {
    display: flex;
    align-self: center;
    flex-wrap: nowrap;
    align-items: center;
    align-content: center;
    justify-content: center;

    width: 100%;

    overflow-x: scroll;
    overflow-y: hidden;

    padding-top: 4%;
    height: 90%;
}

.lateral {
    width: 5%;
}

.rightbutton {
    margin-right: 3%;
}

.leftbutton {
    margin-left: 3%;
}

#back[disabled=true] {
    opacity: 0.7;
    z-index: -1;
}

#forward[disabled=true] {
    opacity: 0.7;
}

.score {
    width: 80%;
    height: 100%;

    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
}

.score-container-rhythm-canvas {
    max-width: 100vw;
    max-height: 100vh;
    overflow-x: scroll;
    overflow-y: hidden;
}

.playing-line {
    position: absolute;
    left: 0;
    top: 10%;
    height: 70% !important;
    width: 0.3em;
    background-color: white;
    opacity: 0%;
}

.playing-line.active {
    opacity: 9.0 !important;
    /* after build, only accepts values 0.0-1.0*/
}

.canvas {
    position: absolute;
    top: 0;

    width: auto !important;
    height: 100%;

    z-index: -1 !important;
}

.choose {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    height: 150%;
    padding: 1em;
}

.play-all {
    position: absolute;
    left: 50%;
}

.speed-bar {
    width: 15%;
    position: absolute;
    right: 7%;
    top: 7% !important;
}

#speedbarcoelho{
position: fixed;
right: 4%;
top: 7%;
height: 5%;
float: right;
}

#speedbarcaracol{
 position: fixed;
right: 22%;
top: 7%;
height: 5%;
float: right;
}
input[type=range]{
    -webkit-appearance: none;
}

#Speed-Range-Rhythm {
    height: 5px;
    border-radius: 5px;
    margin-top: 7%;
    outline: none;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
    stroke: none;
    background: #283583;
}

#Speed-Range-Rhythm::-webkit-slider-thumb{
 -webkit-appearance: none;
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: #ffffff;
    margin-top: -13px;
}

#Speed-Range-Rhythm[type=range]::-ms-fill-upper {
    background: #ddd;
    border-radius: 10px;
}




#Speed-Range-Rhythm::before {
    -webkit-appearance: none;
    opacity: 0%;
}

.instrument-mute-all {
    position: absolute;
    bottom: 5%;
    left: 48%;
    opacity: 8.0;
    border-radius: 50%;
    display: flex;
    justify-content: space-around;
    width: 6% !important;
    height: 6%;
    margin-left: 2em;
    z-index: 2;
}



.instrument-mute-all>img {
    width: 1.5em !important;
}

@media only screen and (max-width: 686px) {
    .lateral {
        width: 2.7rem;
        height: 2.7rem;
    }

    .rightbutton {
        margin-right: 3%;
    }

    .edit {
        left: 4.5rem;
    }

    .note {
        margin: 0 -1rem;
        width: 4rem;
    }

    .choose {
        padding: 0.8rem;
    }

    .beat-level-2 {
        margin-top: -1em;
    }

    .beat-level-3 {
        margin-top: 37%;
    }

    .hidden {
        height: 5em;
        width: 2em;
    }

    .score {
        width: 78%;
    }

}

@media only screen and (min-width: 1024px) {

    .lateral {
        width: 4.5rem;
        height: 4.5rem;
    }

    .edit {
        left: 6.5rem;
    }

    .note {
        margin: 0 -1.5rem;
        width: 7rem;
    }

    .score {
        width: 79%;
    }
}

@media only screen and (min-width: 1300px) {

    .lateral {
        width: 6rem;
        height: 6rem;
    }

    .edit {
        left: 7.5rem;
    }

    .note {
        margin: 0 -1.5rem;
        width: 9rem;
    }

    .hidden {
        height: 11.3em;
        width: 6em;
    }

}
</style>
